import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Склейка классов Tailwind.
 *
 * Стандартный помощник shadcn/ui: clsx собирает условные классы, twMerge
 * разрешает конфликты последним значением. Без него `cn('p-2', 'p-4')` дал бы
 * оба класса, и какой победит — зависело бы от порядка в собранном CSS.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Компактный счётчик непрочитанного, как в Telegram.
 *
 * У больших каналов число доходит до миллионов и вылезает за плашку. Telegram
 * сжимает: 1 200 → «1,2K», 5 294 024 → «5,3M». До тысячи — как есть.
 */
export function formatCount(n: number): string {
  if (n < 1000) return String(n);
  if (n < 1_000_000) {
    const k = n / 1000;
    return `${k >= 100 ? Math.round(k) : k.toFixed(1).replace(/\.0$/, "").replace(".", ",")}K`;
  }
  const m = n / 1_000_000;
  return `${m >= 100 ? Math.round(m) : m.toFixed(1).replace(/\.0$/, "").replace(".", ",")}M`;
}
